(function () {
  const config = window.eclecticGuruSubscriptionDefaults;
  if (!config?.sellingPlanId) return;

  const planId = String(config.sellingPlanId);
  const productHandle = config.productHandle || "goldback-gurus-monthly-subscription-box";

  if (!window.location.pathname.includes(productHandle)) return;

  let pending = null;
  let userChosePurchaseType = false;

  function getWidgets() {
    return Array.from(
      document.querySelectorAll(".sealsubs-container, .sealsubs-target-element")
    );
  }

  function isOneTimeLabel(text) {
    const value = (text || "").toLowerCase();
    return value.includes("one-time") || value.includes("one time");
  }

  function isSubscriptionLabel(text) {
    const value = (text || "").toLowerCase();
    return (
      value.includes("subscribe") ||
      value.includes("deliver every") ||
      value.includes("save")
    );
  }

  function isOneTimeSelected(widgetEl) {
    const emptyPlanRadio = widgetEl.querySelector(
      'input[type="radio"][name*="selling_plan"][value=""]'
    );
    if (emptyPlanRadio?.checked) return true;

    const sellingPlanSelect = widgetEl.querySelector('select[name="selling_plan"]');
    if (sellingPlanSelect && !sellingPlanSelect.value) return true;

    return false;
  }

  function markUserChoiceFromTarget(target) {
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) {
      return;
    }

    if (!target.name?.includes("selling_plan")) return;

    userChosePurchaseType = true;
  }

  function bindUserChoiceListeners(widgetEl) {
    if (widgetEl.dataset.eclecticChoiceBound === "true") return;
    widgetEl.dataset.eclecticChoiceBound = "true";

    widgetEl.addEventListener(
      "change",
      (event) => {
        markUserChoiceFromTarget(event.target);
      },
      true
    );

    widgetEl.addEventListener(
      "click",
      (event) => {
        const label = event.target.closest?.("label");
        if (!label) return;

        const text = label.textContent || "";
        if (isOneTimeLabel(text) || isSubscriptionLabel(text)) {
          userChosePurchaseType = true;
        }
      },
      true
    );
  }

  function selectSubscription(widgetEl) {
    if (!widgetEl || userChosePurchaseType || isOneTimeSelected(widgetEl)) {
      return false;
    }

    bindUserChoiceListeners(widgetEl);

    widgetEl.dispatchEvent(
      new CustomEvent("sealsubs:change_selected_selling_plan_id", {
        detail: { selling_plan_id: planId },
        bubbles: true,
      })
    );

    const planRadio = widgetEl.querySelector(
      `input[type="radio"][value="${planId}"]`
    );
    if (planRadio && !planRadio.checked) {
      planRadio.checked = true;
      planRadio.dispatchEvent(new Event("change", { bubbles: true }));
      planRadio.click();
      return true;
    }

    const sellingPlanRadio = widgetEl.querySelector(
      'input[type="radio"][name*="selling_plan"]:not([value=""])'
    );
    if (sellingPlanRadio && !sellingPlanRadio.checked) {
      sellingPlanRadio.checked = true;
      sellingPlanRadio.dispatchEvent(new Event("change", { bubbles: true }));
      sellingPlanRadio.click();
      return true;
    }

    const sellingPlanSelect = widgetEl.querySelector('select[name="selling_plan"]');
    if (sellingPlanSelect && sellingPlanSelect.value !== planId) {
      sellingPlanSelect.value = planId;
      sellingPlanSelect.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    for (const label of widgetEl.querySelectorAll("label")) {
      const text = label.textContent || "";
      if (isOneTimeLabel(text) || !isSubscriptionLabel(text)) continue;
      label.click();
      return true;
    }

    return false;
  }

  function selectAll() {
    if (userChosePurchaseType) return false;

    const widgets = getWidgets();
    if (!widgets.length) return false;

    widgets.forEach((widget) => {
      bindUserChoiceListeners(widget);
      selectSubscription(widget);
    });
    return true;
  }

  function scheduleSelect() {
    if (userChosePurchaseType) return;

    if (pending) window.clearTimeout(pending);
    pending = window.setTimeout(() => {
      pending = null;
      let tries = 0;
      const attempt = () => {
        if (userChosePurchaseType) return;
        if (selectAll() || ++tries >= 25) return;
        window.setTimeout(attempt, 120);
      };
      attempt();
    }, 50);
  }

  document.addEventListener("sealsubs:subscription_widget_created", (event) => {
    if (userChosePurchaseType) return;

    const widget = event.detail?.element;
    if (widget) {
      bindUserChoiceListeners(widget);
      selectSubscription(widget);
      return;
    }
    scheduleSelect();
  });

  document.addEventListener("sealsubs:loaded", scheduleSelect);
  document.addEventListener("variant:update", scheduleSelect);
  document.addEventListener("variant:selected", scheduleSelect);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleSelect);
  } else {
    scheduleSelect();
  }

  const observer = new MutationObserver(() => {
    if (userChosePurchaseType) {
      observer.disconnect();
      return;
    }

    if (getWidgets().length) scheduleSelect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();